import React, { useEffect, useState } from 'react'
import { calculateReportsCounts, checkTimesheetStatus, makeSideBarActive } from '../../utils/EllowUtils';
import Styles from "./styles.module.scss";
import * as CONSTANTS from '../../utils/CONSTANTS';
import SideMenu from '../sideMenu';
import DashboardHeader from '../topbar';
import { getClientwiseSalaryReport, getContractReport, getInvoiceReports, getTimesheetNumbersCompanywise, getTimeSheetReports, } from './services';
import App from "./main"
import Table from '../../components/table/index'
import { Label } from '@progress/kendo-react-labels';
import Headline5 from '../../components/headings/Headline5'
import file_download from "../../assets/images/file_download.svg"
import { CFB, SSF, read, readFile, set_cptable, set_fs, stream, utils, version, write, writeFile, writeFileAsync, writeFileXLSX, writeXLSX } from 'xlsx';

function Reports() {

  const menu = makeSideBarActive(CONSTANTS.sideMenu, 4)
  const BreadcrumsValues = ["Reports"]
  const [reportsData, setReportsData] = useState<any>()
  const [invoiceReportsData, setInvoiceReportsData] = useState<any>()
  const [result1, setResult1] = useState<any>()
  const [result2, setResult2] = useState<any>()
  const [timesheetNumbers, setTimesheetNumbers] = useState<any>()
  const [salaryBillReport, setSalaryBillReport] = useState<any>()
  const [contractNumbers, setContractNumbers] = useState<any>()
  const [total, setTotal] = useState<number>()
  const [total2, setTotal2] = useState<number>()

  const [rep1results, setRep1results] = useState<any>()
  const [rep2results, setRep2results] = useState<any>()

  useEffect(() => {
 
    getTimesheetReportsData('')
    getInvoiceReportsData('')
    getTimesheetNumbers()
    getClientwiseSalary()
    getContractNumbers('')
  }, [])
  
  let presentMonth = new Date().getMonth() + 1;
  let presentYear = new Date().getFullYear()


  const getContractNumbers = (filters?: any) => {
    let body: any;

    if (filters && filters !== '') {
      body = {
        filters
      }
    }
    else {
      body = {
        filters:
        {
          month: presentMonth,
          year: presentYear
        }
      }
    }
    getContractReport(body).then((response: any) => {
      setContractNumbers([response])
    })
  }

  const getClientwiseSalary = () => {
    let body = {}
    getClientwiseSalaryReport(body).then((response: any) => {
      setSalaryBillReport(response)
    })
  }

  const getTimesheetNumbers = () => {
    getTimesheetNumbersCompanywise().then((response: any) => {
      if (response && response.status === 1) {
            setTimesheetNumbers(response.data)
          }
    })
  }

  const getInvoiceReportsData = (filters?: any) => {
    let body: any;

    if (filters && filters !== '') {
      body = {
        filters
      }
    }
    else {
      body = {
        filters:
        {
          month: presentMonth,
          year: presentYear
        }
      }
    }
  
    getInvoiceReports(body).then((response: any) => {
      if (response && response.status === 1) {
        setInvoiceReportsData(response.data.timesheetReports)
      }
    })


  }

  const getTimesheetReportsData = (filters?: any) => {
    let body: any;

    if (filters && filters !== '') {
      body = {
        filters
      }
    }
    else {
      body = {
        filters:
        {
          month: presentMonth,
          year: presentYear
        }
      }
    }

    getTimeSheetReports(body).then((response: any) => { 
      if (response && response.status === 1) {
        setReportsData(response.data.timesheetReports)    
      }
    })   
  }

  const applyFilter = (data: any) => {    
    getTimesheetReportsData(data)
    getInvoiceReportsData(data)
    getContractNumbers(data)
  }
  
  const getCounts1 = (data: any) => {

    if (data) {
      setResult1(data.data) 
     
        setTotal(data.total)

    }
  }

  const getCounts2 = (data: any) => {
    if (data) {
      setResult2(data.data)  
      setTotal2(calculateReportsCounts(data.data).totalCandidates)
    }
  }

  const sample = (value: any) => {
  }

  const downloadReports = (report1Data: any, report2Data: any) => {

    const newData1 = report1Data && report1Data.map((item: any) => ({
      candidateName: item.candidateName,
      companyName: item.companyName,
      candidateType: item.candidateType,
      submittedOn: item.submittedOn ? new Date(parseInt(item.submittedOn)).toDateString(): '',
      approvedOn: item.approvedOn ? new Date(parseInt(item.approvedOn)).toDateString() : '',
      providerName: item.providerName,
      timesheetStatus: item.status,
      contractStartDate: item.contractStartDate ? new Date(parseInt(item.contractStartDate)).toDateString() : '',
      contractEndDate: item.contractEndDate ? new Date(parseInt(item.contractEndDate)).toDateString() : '',
      candidateRate: item.candidateRate,
      totalWorkingDays: item.totalWorkingDays,
      actualWorkingDays: item.actualWorkingDays,
      maximumPayableAmount: item.maximumPayableAmount,
      candidateOverallPay: item.candidateOverallPay,
      diffrence: item.difference
    }))

    const newData2 = report2Data && report2Data.map((item: any) => ({
      candidateName: item.candidateName,
      companyName: item.companyName,
      candidateType: item.candidateType,
      submittedOn: item.submittedOn ? new Date(parseInt(item.submittedOn)).toDateString() : '',
      approvedOn: item.approvedOn ? new Date(parseInt(item.approvedOn)).toDateString() : '',
      providerName: item.providerName,
      timesheetStatus: item.status,
      contractStartDate: item.contractStartDate ? new Date(parseInt(item.contractStartDate)).toDateString() : '',
      contractEndDate: item.contractEndDate ? new Date(parseInt(item.contractEndDate)).toDateString() : '',
      candidateRate: item.candidateRate,
      totalWorkingDays: item.totalWorkingDays,
      actualWorkingDays: item.actualWorkingDays,
      maximumPayableAmount: item.maximumPayableAmount,
      estimatedInvoiceAmount: item.estimatedInvoiceAmount,
      actualInvoiceAmount: item.actualInvoiceAmount,
      difference: item.difference
    }))

    
    var wb = utils.book_new(),
        ws  = utils.json_to_sheet(newData1);
    var ws1 = utils.json_to_sheet(newData2)
    var ws2 = utils.json_to_sheet(salaryBillReport)
    var ws3 = utils.json_to_sheet(contractNumbers)
    var ws4 = utils.json_to_sheet(timesheetNumbers)

    utils.book_append_sheet(wb, ws, 'Timesheet Reports')
    utils.book_append_sheet(wb, ws1, 'Client Invoice Reports')
    utils.book_append_sheet(wb, ws2, 'Clientwise salary report')
    utils.book_append_sheet(wb, ws3, 'Number of Contracts')
    utils.book_append_sheet(wb, ws4, 'Companywise Timesheets')
    writeFile(wb, `Reports.Xlsx`)
    
  }

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} opentimesheet={'reports'}/>
      <div className="dashboardContent">
        <DashboardHeader
          title={BreadcrumsValues}
        //  navigateTo="../createCompany"
          type='reports'
          searchChange={''}
          timeSheetReportsFilter={applyFilter}
        />
        
        <section className={Styles.dashboardWrapper}>
          
      {/* <App /> ₹*/}
      <div className="contentBox">
            <div className="innerPadd24">
            <div className={Styles.reportInfoWrap1}>
              <Headline5>Timesheet Reports</Headline5> 
              <img src={file_download} onClick={() => downloadReports(rep1results.data, rep2results.data)}></img>
              <p onClick={() => downloadReports(rep1results.data, rep2results.data)}>Export as excel</p>
            </div>
              <div className={Styles.reportInfoWrap}> 
                <p className={Styles.reportInfoItem}>{`Total candidates: `}<span>{calculateReportsCounts(result1).totalCandidates}</span></p>
                <p className={Styles.reportInfoItem}>{`Sum of Estimate: `}<span>₹{calculateReportsCounts(result1) && calculateReportsCounts(result1).estimateSum && calculateReportsCounts(result1).estimateSum.toFixed(1)}</span></p>
                <p className={Styles.reportInfoItem}>{`Total net pay: `}<span>₹{calculateReportsCounts(result1) && calculateReportsCounts(result1).netPaySum && calculateReportsCounts(result1).netPaySum.toFixed(1)}</span></p>
                <p className={Styles.reportInfoItem}>{`Sum of difference: `}<span>₹{calculateReportsCounts(result1) && calculateReportsCounts(result1).differenceSum && calculateReportsCounts(result1).differenceSum.toFixed(1)}</span></p>
              </div>
              <div className='breakTableTh'>
                <Table type='ReportsTable1' data={reportsData} counts={getCounts1} pageSize={sample} total={total} filtereResults={setRep1results}/>
              </div>
        </div>
      </div>
        </section>
       
        <section className={Styles.dashboardWrapper}>
      
      <div className="contentBox">
            <div className="innerPadd24">
            <Headline5>Client Invoice Reports</Headline5>
              <div className={Styles.reportInfoWrap}> 
                <p className={Styles.reportInfoItem}>{`Total candidates: `}<span>{calculateReportsCounts(result2).totalCandidates}</span></p>
                <p className={Styles.reportInfoItem}>{`Sum of Maximum: `}<span>₹{calculateReportsCounts(result2) && calculateReportsCounts(result2).maximumSum && calculateReportsCounts(result2).maximumSum.toFixed(1)}</span></p>
                <p className={Styles.reportInfoItem}>{`Sum of Estimate: `}<span>₹{calculateReportsCounts(result2) && calculateReportsCounts(result2).estimateInvoiceSum && calculateReportsCounts(result2).estimateInvoiceSum.toFixed(1)}</span></p>
                <p className={Styles.reportInfoItem}>{`Sum of Actual pay: `}<span>₹{calculateReportsCounts(result2) && calculateReportsCounts(result2).actualInvoicesum && calculateReportsCounts(result2).actualInvoicesum.toFixed(1)}</span></p>
                <p className={Styles.reportInfoItem}>{`Sum of difference: `}<span>₹{calculateReportsCounts(result2) && calculateReportsCounts(result2).differenceSum && calculateReportsCounts(result2).differenceSum.toFixed(1)}</span></p>
              </div>
              <div className='breakTableTh'>
              <Table type='ReportsTable2' data={invoiceReportsData} counts={getCounts2} pageSize={sample} total={total2} filtereResults={setRep2results}/>
              </div>
        </div>
      </div>
        </section>
        <Label> Number of timesheets in different stages company-wise</Label>
        <Table type='ReportsTable5' data={timesheetNumbers} total={timesheetNumbers && timesheetNumbers.length} counts={getCounts2} pageSize={sample} />



        <section className={Styles.dashboardWrapper}>
         <div className="contentBox">
           <div className="innerPadd24">
        <Headline5>Client-wise salary and bill report</Headline5>
        <div className='breakTableTh'>
            <Table type='ReportsTable3' data={salaryBillReport} total={salaryBillReport && salaryBillReport.length} pageSize={sample} />
            </div>
           </div>
         </div>
        </section>


      <section className={Styles.dashboardWrapper}>
        <div className="contentBox">
         <div className="innerPadd24">
        <Headline5>Number of Contracts</Headline5>
        <div className='breakTableTh'>
          <Table type='ReportsTable4' data={contractNumbers} total={salaryBillReport && salaryBillReport.length} pageSize={sample} />
         </div>
         </div>
        </div>
      </section>

       
        <section className={Styles.dashboardWrapper}>
        <div className="contentBox">
           <div className="innerPadd24">
        <Headline5> Number of timesheets in different stages company-wise</Headline5>
        <div className='breakTableTh'>
              <Table type='ReportsTable5' data={timesheetNumbers} total={timesheetNumbers && timesheetNumbers.length} pageSize={sample} />
              </div>
              </div>
         </div>
        </section>

      </div>
    </section>
  )
}

export default Reports